import { Component } from '@angular/core';

import { GoalStatisticsService } from '../../service/statistics/statistics.service';

@Component({
    selector: 'app-goal-box-statistics-column',
    templateUrl: './box-statistics-column.component.html',
    styleUrls: ['./box-statistics-column.component.scss'],
    standalone: false,
})
export class GoalBoxStatisticsColumnComponent {
    // eslint-disable-next-line @angular-eslint/prefer-inject
    constructor(private goalStatisticsService: GoalStatisticsService) {}

    /**
     * Statistics
     */
    get statistics() {
        return this.goalStatisticsService.statistics;
    }
}
